// // frontend/src/context/AuthContext.jsx
// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { authAPI } from '../services/auth';

// const AuthContext = createContext();

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(localStorage.getItem('access_token'));
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const initAuth = async () => {
//       const storedToken = localStorage.getItem('access_token');
//       if (storedToken) {
//         try {
//           const userProfile = await authAPI.getProfile();
//           setUser(userProfile);
//           setToken(storedToken);
//         } catch (error) {
//           localStorage.removeItem('access_token');
//           localStorage.removeItem('refresh_token');
//         }
//       }
//       setLoading(false);
//     };

//     initAuth();
//   }, []);

//   const login = async (email, password) => {
//     try {
//       const response = await authAPI.login(email, password);
//       setToken(response.access_token);
//       localStorage.setItem('access_token', response.access_token);
//       localStorage.setItem('refresh_token', response.refresh_token);
      
//       const userProfile = await authAPI.getProfile();
//       setUser(userProfile);
      
//       return { success: true };
//     } catch (error) {
//       return { success: false, error: error.message };
//     }
//   };

//   const register = async (userData) => {
//     try {
//       await authAPI.register(userData);
//       return { success: true };
//     } catch (error) {
//       return { success: false, error: error.message };
//     }
//   };

//   const logout = () => {
//     setUser(null);
//     setToken(null);
//     localStorage.removeItem('access_token');
//     localStorage.removeItem('refresh_token');
//   };

//   const value = {
//     user,
//     token,
//     login,
//     register,
//     logout,
//     isAuthenticated: !!token,
//     loading
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };





// frontend/src/context/AuthContext.jsx - Updated to use real backend
import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('access_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem('access_token');
      if (storedToken) {
        try {
          // Get user profile from backend
          const userProfile = await authAPI.getProfile();
          setUser(userProfile);
          setToken(storedToken);
        } catch (error) {
          console.error('Failed to get user profile:', error);
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          setToken(null);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    try {
      setLoading(true);
      const response = await authAPI.login(email, password);
      
      setToken(response.access_token);
      localStorage.setItem('access_token', response.access_token);
      localStorage.setItem('refresh_token', response.refresh_token);
      
      // Get user profile after login
      const userProfile = await authAPI.getProfile();
      setUser(userProfile);
      
      return { success: true };
    } catch (error) {
      console.error('Login failed:', error);
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const register = async (userData) => {
    try {
      setLoading(true);
      const response = await authAPI.register(userData);
      
      // After successful registration, log the user in
      if (response.message) {
        const loginResult = await login(userData.email, userData.password);
        return loginResult;
      }
      
      return { success: true };
    } catch (error) {
      console.error('Registration failed:', error);
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  };

  const updateProfile = async (userData) => {
    try {
      const updatedUser = await authAPI.updateProfile(userData);
      setUser(updatedUser);
      return { success: true };
    } catch (error) {
      console.error('Profile update failed:', error);
      return { success: false, error: error.message };
    }
  };

  const deleteAccount = async () => {
    try {
      await authAPI.deleteAccount();
      logout();
      return { success: true };
    } catch (error) {
      console.error('Account deletion failed:', error);
      return { success: false, error: error.message };
    }
  };

  const value = {
    user,
    token,
    login,
    register,
    logout,
    updateProfile,
    deleteAccount,
    isAuthenticated: !!token,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
